import cookies from 'js-cookie';

class setCookieOnClick {
  constructor(element) {
    this.element = element;

    this.bindEvents();
  }

  bindEvents() {
    this.element.addEventListener('click', (e) => this.setCookie(e));
  }

  setCookie(e) {
    e.preventDefault();
    const { cookieObject, cookieName, cookieValue, expires, domain, goToHref } = this.element.dataset;

    const config = {};
    if (expires) config.expires = parseInt(expires, 10);
    if (domain) config.domain = domain;

    if(cookieObject) {
      JSON.parse(cookieObject).forEach(cookie => {
        cookies.set(cookie.name, cookie.value, config);
      })
    } else {
      cookies.set(cookieName, cookieValue, config);
    }

    if(goToHref) window.location.href = this.element.href;
  }
}

export default setCookieOnClick;
